import { Flex } from '@revenuemarket/cds';
import { getPartnerByHostname } from '@revenuemarket/utils/partners/getPartnerByHostname';
import Image from 'next/image';

import LightThemeLogo from '~assets/images/clobe_light_theme.svg';
import { css } from '~libs/emotion';

const UnauthenticatedLayout = ({
  children,
  logo = LightThemeLogo,
  host,
  showLogoOnMobile = true,
  customHeader,
}: {
  children: React.ReactNode;
  logo?: string;
  host?: string;
  showLogoOnMobile?: boolean;
  customHeader?: React.ReactNode;
}) => {
  const partner = getPartnerByHostname(host ?? '');
  const showLogo = partner ? false : true;

  return (
    <div
      className={css`
        width: 100vw;
        height: 100vh;
        padding: 40px;
        @media (max-width: 768px) {
          padding: 20px;
        }
      `}
    >
      {customHeader ? (
        customHeader
      ) : (
        <div
          style={{ position: 'relative', cursor: 'pointer' }}
          onClick={() => {
            window.location.href = 'https://clobe.ai/';
          }}
        >
          {showLogo && (
            <Image
              src={LightThemeLogo}
              alt="logo"
              className={css`
                width: 120px;
                height: 24px;
                position: absolute;
                top: 0;
                left: 0;
                @media (max-width: 768px) {
                  position: relative;
                  display: ${showLogoOnMobile ? 'block' : 'none'};
                }
              `}
            />
          )}
        </div>
      )}
      <Flex
        align="center"
        justify="center"
        style={{
          height: '100%',
        }}
        className={css`
          @media (max-width: 768px) {
            width: 100%;
            margin-top: 80px;
            align-items: flex-start !important;
          }
        `}
      >
        {children}{' '}
      </Flex>
    </div>
  );
};

export default UnauthenticatedLayout;
